module.exports = __webpack_public_path__ + "img/File-doc.1c208603.svg";